import './disableProdLogging';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { STORAGE_KEYS } from './auth/storageKeys';

if (globalThis.location?.pathname === '/impersonate-login') {
  const storage = globalThis.sessionStorage;
  if (storage) {
    storage.removeItem(STORAGE_KEYS.token);
    storage.removeItem(STORAGE_KEYS.role);
    storage.removeItem(STORAGE_KEYS.principal);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

reportWebVitals();
